import {
  ACCEPT_DATA_MODAL_FORM,
  ROW_MODAL_FORM_DESELECTED,
  ROW_MODAL_FORM_SELECTED,
} from '../../actions/ui/selectRowTableModal';

export const initialState = {};

type actionType = {
  type: string;
  payload: { id: string; data: unknown };
};

export default function selectedDataTableModal(
  state = initialState,
  { type, payload }: actionType
) {
  switch (type) {
    case ROW_MODAL_FORM_SELECTED:
      // Handle two cases:
      // 1. payload.data is already structured with { data: {...}, isShowedData: boolean }
      //    (e.g., from duplicate communication loader)
      // 2. payload.data is raw data object (e.g., from modal selection)
      const hasStructure =
        payload.data &&
        typeof payload.data === 'object' &&
        'data' in payload.data &&
        'isShowedData' in payload.data;

      return {
        ...state,
        [payload.id]: {
          id: payload.id,
          data: hasStructure ? (payload.data as any).data : payload.data,
          isShowedData: hasStructure
            ? (payload.data as any).isShowedData
            : false,
        },
      };
    case ACCEPT_DATA_MODAL_FORM:
      return {
        ...state,
        [payload.id]: {
           
          // @ts-ignore
          ...state[payload.id],
          isShowedData: true,
        },
      };
    case ROW_MODAL_FORM_DESELECTED: {
      const newStateUnset = { ...state };
       
      // @ts-ignore
      delete newStateUnset[payload.id];
      return newStateUnset;
    }
    default:
      return state;
  }
}
